import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/comandas';
import Comandas from './ComandasList';


const ms2p = (state) => {
  return {
    ...state.comanda_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Comandas);
